import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@features/ui';
import { EmailIcon } from '@features/ui/icons';
import { SUPPORT_EMAIL } from '@src/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const ForgotEmailPopup: React.FC<Props> = ({ open, onOpenChange }) => {
  const { t } = useTranslation();

  function openEmailInNewTab(to: string, subject: string = '') {
    const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}`;

    window.location.href = mailtoLink;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[500px] max-w-[90vw] mx-auto">
        <DialogHeader className="mb-5">
          <DialogTitle className="text-2xl text-center mb-[23px]">
            {t('common.form.forgotEmail')}
          </DialogTitle>
          <DialogDescription className="text-center text-white text-[16px]">
            {t('common.form.contactSupportDes')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex items-center justify-center">
            <EmailIcon className="text-primary" height={24} width={24} />
            <Button
              className="underline text-xl p-2"
              variant={'link'}
              onClick={() => {
                openEmailInNewTab(SUPPORT_EMAIL, 'Forgot Email');
                onOpenChange(false);
              }}
            >
              {t('common.form.contactSupport')}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
